import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61678aaf"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]


export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
  type: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
  },
},
  emits: ["click"],
  setup(__props, { emit }) {

const props = __props





function onClick(mouseEvent: MouseEvent): void {
  emit("click");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["normal", __props.type]),
    disabled: __props.disabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick($event)))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})